module.exports = __webpack_public_path__ + "img/gexing@2x.546a87f0.png";